import { useEffect, useState } from 'react';
import { IAppConfigResult, useAppConfig } from '../../../../../libs/hooks/useAppConfig';
import { IAppConfigValue } from '../../../../../libs/services/AppConfigService';
import { useAppSelector } from '../../../../../redux/app/hooks';
import { RootState } from '../../../../../redux/app/store';
import { ModalDialog } from '../Shared/ModalDialog';

interface IEffectivePromptsDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
}

export const EffectivePromptsDialog: React.FC<IEffectivePromptsDialogProps> = ({ open, setOpen }) => {
    const [promptGuidanceContent, setPromptGuidanceContent] = useState<string>('');

    const { activeUserInfo } = useAppSelector((state: RootState) => state.app);
    const emailAddress = activeUserInfo?.email ?? '';
    const user = emailAddress;

    const appConfig = useAppConfig();

    const getPromptGuidanceContent = async () => {
        const response: IAppConfigResult<IAppConfigValue> = await appConfig.getConfigSingleValue(
            'Prompt Guidance',
            user,
        );

        if (response.Success) {
            setPromptGuidanceContent(response.Data?.Value ?? '');
        }
    };

    useEffect(() => {
        getPromptGuidanceContent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!promptGuidanceContent) {
        return null; // Add fallback UI
    }

    return (
        <ModalDialog
            title={`Prompt guidance for ${import.meta.env.VITE_APP_NAME}`}
            open={open}
            onClose={() => setOpen(false)}>
            <div
                className="[&>h3]:font-bold [&>h3]:mb-2 [&>p]:mb-4"
                dangerouslySetInnerHTML={{ __html: promptGuidanceContent }}
            />
        </ModalDialog>
    );
};
